(() => {
    function init() {
        const selects = document.querySelectorAll('.select-your-vehicle select')
        selects.forEach(select => {
            select.addEventListener('change', function (event) {
                const value = event.currentTarget.value
                const option = event.currentTarget.querySelector(`option[value="${value}"]`)
                const vehicle_image = option.dataset.vehicleImage
                const card = event.currentTarget.closest('.new-truck-flow-item')
                const image = card.querySelector('.new-truck-flow-item__image img')

                // Adicionar spinner
                const spinner = document.createElement('div')
                spinner.className = 'spinner'
                card.querySelector('.new-truck-flow-item__image').appendChild(spinner)


                image.src = vehicle_image
                image.currentSrc = vehicle_image;

                image.onload = function () {
                    // Remover spinner quando a imagem terminar de carregar
                    spinner.remove()
                    image.style.display = ''
                }

                image.onerror = function () {
                    // Remover spinner e mostrar mensagem de erro se a imagem falhar ao carregar
                    spinner.remove()
                    image.style.display = ''
                    console.error('Erro ao carregar a imagem:', vehicle_image)
                }

                const anchor = card.querySelector('a')
                anchor.href = `/collections/${value}`
            })
        })

    }
    document.addEventListener('DOMContentLoaded', init)
})()